import { Link } from 'react-router-dom';
import { trackEvent, WEB_QUIZ_SELECT } from '../../lib/analytics';
import type { QuizMeta } from '../../lib/quizData';
import styles from './QuizCategoryCard.module.css';

import softImg from '../../assets/images/dares/soft.png';
import steamyImg from '../../assets/images/dares/steamy.png';
import wildImg from '../../assets/images/dares/wild.png';
import hardcoreImg from '../../assets/images/dares/hardcore.png';

const BG_MAP: Record<string, string> = {
  mild: softImg,
  hot: steamyImg,
  spicy: wildImg,
  crazy: hardcoreImg,
  unfiltered: hardcoreImg,
  extreme: hardcoreImg,
};

interface Props {
  quiz: QuizMeta;
}

export function QuizCategoryCard({ quiz }: Props) {
  const bg = BG_MAP[quiz.id] ?? softImg;
  const locked = quiz.isLocked && !quiz.isShareToUnlock;
  const href = locked ? `/quiz/${quiz.id}/locked` : `/quiz/${quiz.id}`;

  function handleClick() {
    void trackEvent(WEB_QUIZ_SELECT, {
      quiz_id: quiz.id,
      is_locked: locked,
    });
  }

  return (
    <Link to={href} className={`${styles.card} ${locked ? styles.locked : ''}`} onClick={handleClick}>
      <div className={styles.bgWrap}>
        <img src={bg} alt="" className={styles.bgImg} />
        <div className={styles.overlay} />
      </div>
      <div className={styles.content}>
        <div className={styles.top}>
          <span className={styles.count}>{quiz.questionCount} questions</span>
          {locked && <span className={styles.lockBadge}>🔒</span>}
          {quiz.isShareToUnlock && <span className={styles.shareBadge}>Share to Unlock</span>}
        </div>
        <h3 className={styles.name}>{quiz.name}</h3>
        <p className={styles.desc}>{quiz.description}</p>
        <span className={styles.cta}>
          {locked ? 'Get the App to Unlock' : 'Play Now'}
        </span>
      </div>
    </Link>
  );
}
